import React from "react";
import Fab from "@mui/material/Fab";
import Stack from "@mui/material/Stack";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import CardContent from "@mui/material/CardContent";
import CardActionArea from "@mui/material/CardActionArea";
//UTILS
import axios from "../../../../../../shared/axios/axiosProxy";
import i18n from "../../../../../../utils/i18n";
//REDUX
import ACTIONS from "../../../../../../redux/action";
import { connect } from "react-redux";
import { Avatar } from "@mui/material";
import ProfileIconDefaultAvatar from "../../../../../../images/profile-icon-default-avatar.svg";
import ImageCropDialog from "../../../../../components/ImageCropDialog";

const mapStateToProps = (state) => ({
  provider_media: state.provider_media,
  providerID: state.providerID,
});
const mapDispatchToProps = (dispatch) => ({
  addProviderInfo: (item) => dispatch(ACTIONS.addProviderInfo(item)),
});

class ImageUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mainState: "initial", // initial, search, gallery, uploaded
      imageUploaded: 0,
      selectedFile: ProfileIconDefaultAvatar,
      isUploading: false,
      uploadError: null,
      uploadSuccess: false,
      cropSource: null,
    };
  }

  componentDidMount() {
    if (this.props.provider_media.profileImage) {
      this.setState({
        mainState: "uploaded",
        selectedFile: this.props.provider_media.profileImage,
        imageUploaded: 1,
      });
    } else {
      this.setState({
        mainState: "initial",
        imageUploaded: 0,
        selectedFile: ProfileIconDefaultAvatar,
      });
    }
  }

  fileInputRef = React.createRef();

  static handleCustomButtonClick = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  handleUploadClick = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith("image/")) {
      this.setState({
        uploadError: i18n.t("provider.onlyimagefiles"),
        uploadSuccess: false,
      });
      return;
    }

    // Validate file size (5MB max)
    if (file.size > 5 * 1024 * 1024) {
      this.setState({
        uploadError: i18n.t("provider.filetoobig"),
        uploadSuccess: false,
      });
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {
      // Let the user frame the picture before anything is uploaded
      this.setState({
        cropSource: reader.result,
        uploadError: null,
        uploadSuccess: false,
      });
    };

    // Allow selecting the same file again after cancelling
    event.target.value = "";
  };

  handleCropCancel = () => {
    this.setState({ cropSource: null });
  };

  handleCropConfirm = async (imageData) => {
    this.setState({
      cropSource: null,
      isUploading: true,
      uploadError: null,
      uploadSuccess: false,
      selectedFile: imageData,
      mainState: "uploaded",
      imageUploaded: 1,
    });

    const JWT = localStorage.getItem("JWT");

    try {
      const response = await axios.patch(
        "/api/provider/picture",
        {
          provider_media: { profileImage: "" }, // Will be set by backend
          image: imageData,
          providerID: this.props.providerID, // Add providerID to request
        },
        {
          headers: {
            Authorization: `Bearer ${JWT}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.result === "success" && response.data.imageUrl) {
        // Update Redux with the actual URL from backend
        const imageUrl = response.data.imageUrl;
        this.props.addProviderInfo({
          id: "profileImage",
          data: imageUrl,
          stateObject: "provider_media",
        });

        // The S3 key is the same for every upload, so bypass the browser cache
        this.setState({
          selectedFile: `${imageUrl}${imageUrl.includes("?") ? "&" : "?"}t=${Date.now()}`,
          uploadSuccess: true,
          uploadError: null,
        });
      } else {
        throw new Error(i18n.t("provider.uploadfailed"));
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        i18n.t("provider.uploaderror");
      this.setState({
        uploadError: errorMessage,
        uploadSuccess: false,
        selectedFile:
          this.props.provider_media.profileImage || ProfileIconDefaultAvatar,
      });
    } finally {
      this.setState({
        isUploading: false,
      });
    }
  };

  renderUploadedState() {
    return (
      <React.Fragment>
        {/* <CardActionArea onClick={this.imageResetHandler}> */}
        {/* <img className='user-logo' src={this.state.selectedFile} alt='user' /> */}
        <Avatar
          src={this.state.selectedFile || ProfileIconDefaultAvatar}
          alt="user"
          sx={{ width: 120, height: 120, objectFit: "cover" }}
        />
        {/* </CardActionArea> */}
      </React.Fragment>
    );
  }
  imageResetHandler = (event) => {
    this.setState({
      mainState: "initial",
      selectedFile: null,
      imageUploaded: 0,
    });
  };
  renderInitialState() {
    /*  const { value } = this.state; */
    return (
      // <React.Fragment>
      //   <CardContent>
      //     <Grid container justifyContent='center' alignItems='center'>
      //       <input
      //         className='imageUpload'
      //         accept='image/*'
      //         id='contained-button-file'
      //         multiple
      //         type='file'
      //       // onChange={this.handleUploadClick}
      //       />
      //       {/* <label htmlFor='contained-button-file'>
      //         <Fab component='span'>
      //           <AddPhotoAlternateIcon />
      //         </Fab>
      //       </label> */}
      //     </Grid>
      //   </CardContent>
      // </React.Fragment>
      <Avatar
        src={ProfileIconDefaultAvatar}
        alt="user"
        sx={{ width: 120, height: 120, objectFit: "cover" }}
      />
    );
  }
  render() {
    return (
      <>
        <input
          ref={this.fileInputRef}
          id="file-upload-image"
          type="file"
          style={{ display: "none" }}
          accept="image/*"
          onChange={this.handleUploadClick}
          disabled={this.state.isUploading}
        />
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          {(this.state.mainState === "initial" && this.renderInitialState()) ||
            (this.state.mainState === "uploaded" && this.renderUploadedState())}
        </Stack>

        {/* Error and Success Messages */}
        {this.state.uploadError && (
          <div
            style={{
              color: "#d32f2f",
              fontSize: "14px",
              marginTop: "10px",
              textAlign: "center",
            }}
          >
            {this.state.uploadError}
          </div>
        )}
        {this.state.uploadSuccess && (
          <div
            style={{
              color: "#2e7d32",
              fontSize: "14px",
              marginTop: "10px",
              textAlign: "center",
            }}
          >
            {i18n.t("provider.uploadsuccess")}
          </div>
        )}
        <ImageCropDialog
          open={Boolean(this.state.cropSource)}
          imageSrc={this.state.cropSource}
          onCancel={this.handleCropCancel}
          onConfirm={this.handleCropConfirm}
        />
        {this.state.isUploading && (
          <div
            style={{
              color: "#1976d2",
              fontSize: "14px",
              marginTop: "10px",
              textAlign: "center",
            }}
          >
            {i18n.t("provider.uploadingprogress")}
          </div>
        )}
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageUpload);
